import React from 'react';
import { MapContainer, TileLayer, Marker, Polyline, Popup } from 'react-leaflet';
import { MapPin, Car } from 'lucide-react';
import 'leaflet/dist/leaflet.css';
import L from 'leaflet';

// Fix pour les icônes Leaflet avec webpack
delete L.Icon.Default.prototype._getIconUrl;
L.Icon.Default.mergeOptions({
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
});

// Icônes personnalisées
const spotIcon = new L.Icon({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [25, 41],
  iconAnchor: [12, 41],
  popupAnchor: [1, -34],
  shadowSize: [41, 41],
  className: 'spot-marker'
});

const parkingIcon = new L.Icon({
  iconUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon.png',
  iconRetinaUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-icon-2x.png',
  shadowUrl: 'https://cdnjs.cloudflare.com/ajax/libs/leaflet/1.9.4/images/marker-shadow.png',
  iconSize: [20, 33],
  iconAnchor: [10, 33],
  popupAnchor: [1, -30],
  shadowSize: [33, 33],
  className: 'parking-marker'
});

const MiniMap = ({ spot, parking, className = "" }) => {
  if (!spot?.coordinates || !parking?.coordinates) {
    return (
      <div className={`h-48 bg-gray-100 rounded-lg flex items-center justify-center ${className}`}>
        <p className="text-gray-500">Carte non disponible</p>
      </div>
    );
  }

  const spotCoords = [spot.coordinates.lat, spot.coordinates.lng];
  const parkingCoords = [parking.coordinates.lat, parking.coordinates.lng];
  
  // Calculer le centre et le zoom approprié
  const bounds = L.latLngBounds([spotCoords, parkingCoords]);
  const center = bounds.getCenter();
  
  // Ligne de chemin entre parking et spot
  const pathLine = [parkingCoords, spotCoords];

  return (
    <div className={`rounded-lg overflow-hidden shadow-md ${className}`}>
      <MapContainer
        center={[center.lat, center.lng]}
        zoom={16}
        style={{ height: '200px', width: '100%' }}
        scrollWheelZoom={false}
        zoomControl={true}
        attributionControl={true}
      >
        <TileLayer
          attribution='&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors'
          url="https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png"
        />
        
        {/* Marqueur du spot */}
        <Marker position={spotCoords} icon={spotIcon}>
          <Popup>
            <div className="text-center">
              <MapPin className="w-4 h-4 mx-auto mb-1 text-amber-600" />
              <strong>Spot panoramique</strong>
              <br />
              <span className="text-sm text-gray-600">{spot.title}</span>
            </div>
          </Popup>
        </Marker>
        
        {/* Marqueur du parking */}
        <Marker position={parkingCoords} icon={parkingIcon}>
          <Popup>
            <div className="text-center">
              <Car className="w-4 h-4 mx-auto mb-1 text-blue-600" />
              <strong>Parking</strong>
              <br />
              <span className="text-sm text-gray-600">{parking.name || 'Zone de stationnement'}</span>
            </div>
          </Popup>
        </Marker>
        
        {/* Ligne entre parking et spot */}
        <Polyline 
          positions={pathLine} 
          color="#F59E0B" 
          weight={3}
          opacity={0.7}
          dashArray="5, 5"
        />
      </MapContainer>
      
      {/* Légende */}
      <div className="bg-white px-3 py-2 text-xs text-gray-600 border-t">
        <div className="flex items-center justify-between">
          <div className="flex items-center">
            <div className="w-3 h-3 bg-red-500 rounded-full mr-2"></div>
            <span>Spot panoramique</span>
          </div>
          <div className="flex items-center">
            <div className="w-3 h-3 bg-blue-500 rounded-full mr-2"></div>
            <span>Parking</span>
          </div>
          <div className="flex items-center">
            <div className="w-4 h-0.5 bg-amber-500 mr-2" style={{borderTop: '2px dashed #F59E0B'}}></div>
            <span>Chemin</span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default MiniMap;